import { useState } from 'react';
import { Form, Button, Space, Toast } from 'antd-mobile';
import { UploadOutline, DeleteOutline } from 'antd-mobile-icons'
import 'static/css/upload.css'

/**
 * 上传文件模板
 * @param {
 *  item:对应的表单模板
 *  setFormInfo:向传给接口的对象中新增对应表单数据
 * } props 
 * @returns 
 */
export function BpmFormUpload(props) {
  const { postName, label, message, disabled, required, type, key } = props.item
  const { formId, setFiles, setHousehold, setApplicantPage } = props
  const [fileList, setFileList] = useState([])
  const uploadUrl = '/api1/hrss/upload';
  const deleteUrl = '/api1/hrss/deleteFile';

  // input的点击事件
  const handleInputOnChange = (e) => {
    // 不允许空值
    if (e.target.files.length === 0) {
      return;
    }
    // 限制文件大小为5M
    const isUpload = e.target.files[0].size / 1024 / 1024 < 5;
    if (!isUpload) {
      Toast.show({
        icon: 'fail',
        content: '上传文件大小不得超过5M',
      })
    } else {
      // 获取上传文件的信息
      const formData = new FormData();
      const upFileArr = Array.from(e.target.files);
      upFileArr.forEach(file => {
        formData.append('file', file);
      })
      if (type === 'fileForm') {
        if (key === 'onlyOne') {
          handleDelete(0)
        }
        fileList.push(...upFileArr)
        if (key === 'onlyOne' && setFiles) {
          setFiles(fileList)
        }
        if(postName ==='FApplicantPage' && setApplicantPage){
          setApplicantPage(fileList)
        }
        if(postName ==='FHousehold'&& setApplicantPage){
          setHousehold(fileList)
        }
        if(postName ==='FOtherDocuments'&& setApplicantPage){
          setFiles(fileList)
        }
        // if (setFiles && setApplicantPage && setHousehold) {
        //   setFiles(file)
        //   setApplicantPage(file)
        //   setHousehold(file)
        // }
        setFileList([...fileList])
        return
      }
      formData.append('FORMID', formId);
      fetch(uploadUrl, {
        method: 'POST',
        body: formData
      }).then(res => res.json())
        .then(res => {
          if (res.code === 200) {
            Toast.show({
              icon: 'success',
              content: `上传成功`,
            })
            fileList.push(...upFileArr)
            setFileList([...fileList])
            const input = document.getElementById(`${formId} + fileInput`);
            input.value = '';
          } else {
            Toast.show({
              icon: 'fail',
              content: res.msg || '上传失败',
            })
          }
        }).catch(err => {
          Toast.show({
            icon: 'fail',
            content: err.msg || '上传失败',
          })
        })
    }
  }
  // 删除文件
  const handleDelete = (index) => {
    // 获取删除文件的信息
    const deleteFile = fileList[index];
    const formData = new FormData();
    formData.append('file', deleteFile);
    formData.append('FORMID', formId);
    if (type === 'fileForm') {
      if (key === 'onlyOne') {
        fileList.splice(index, 1)
        setFileList([...fileList])
        return
      }
      else {
        Toast.show({
          icon: 'success',
          content: '删除成功',
        })
        fileList.splice(index, 1)
        setFileList([...fileList])
        const input = document.getElementById(`${formId} + fileInput`);
        input.value = '';
        return
      }
    }
    // 调用接口删除文件
    fetch(deleteUrl, {
      method: 'POST',
      body: formData
    }).then(res => res.json())
      .then(res => {
        if (res.code === 200) {
          Toast.show({
            icon: 'success',
            content: res.data || '删除成功',
          })
          fileList.splice(index, 1)
          setFileList([...fileList])
        } else {
          Toast.show({
            icon: 'fail',
            content: res.msg || '删除失败',
          })
        }
      }).catch(err => {
        Toast.show({
          icon: 'fail',
          content: err.msg || '删除失败',
        })
      })
  }
  return (
    <Form.Item
      name={postName}
      label={label}
      rules={[{ required: required, message: message }]}
    >
      <div className='upload'>
        <Button className='uploadButton' size='small' disabled={disabled} >
          <Space>
            <span>{message}</span>
            <UploadOutline />
          </Space>
          {
            key && key === 'onlyOne'
              ?
              <input
                id={`${formId}+${postName} + fileInput`}
                className='fileInput'
                type="file"
                name={`${postName}Upload[]`}
                onChange={(e) => handleInputOnChange(e)}
              />
              :
              <input
                id={`${formId} + fileInput`}
                className='fileInput'
                type="file"
                multiple
                name={`${postName}Upload[]`}
                onChange={(e) => handleInputOnChange(e)}
              />
          }

        </Button>
        {/* 显示上传的文件名 */}
        {fileList.length ? fileList.map((item, index) => {
          return <div className='uploadFileName' key={index}>
            <p>{item.name}</p>
            <DeleteOutline onClick={() => handleDelete(index)} />
          </div>
        })
          : null
        }
      </div>
    </Form.Item >
  )
}